import { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiMenu,
  FiBox,
  FiClipboard,
  FiUsers,
  FiHome,
} from "react-icons/fi";
import { useAuth } from "../context/AuthContext";

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const { user } = useAuth();

  const toggleSidebar = () => setCollapsed(!collapsed);

  const baseLinkClasses =
    "flex items-center gap-3 p-3 rounded-md transition-colors duration-300 font-poppins";

  const activeLinkClasses = "bg-[#B4975A] text-[#121212] shadow-lg";
  const inactiveLinkClasses =
    "text-[#F5F1E9] hover:bg-[#FFD700] hover:text-[#121212]";

  return (
    <aside
      className={`sticky top-0 self-start h-screen overflow-y-auto transition-all duration-300 shadow-xl
        bg-[#121212] border-r border-[#3E3E3E] flex flex-col print:hidden
        ${collapsed ? "w-20" : "w-64"}`}
      style={{ zIndex: 1000 }}
    >
      {/* Sticky toggle header */}
      <div className="sticky top-0 bg-[#121212] z-30 p-4 flex justify-between items-center border-b border-[#3E3E3E]">
        <span
          className={`font-bold text-lg text-[#F5F1E9] tracking-wide select-none font-playfair ${
            collapsed ? "hidden" : ""
          }`}
        >
          Azadi Jewellery
        </span>
        <button
          onClick={toggleSidebar}
          aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
          className="text-[#F5F1E9] hover:text-[#B4975A] transition-colors"
        >
          <FiMenu size={24} />
        </button>
      </div>

      <nav className="flex flex-col gap-2 p-4">
        <NavLink
          to="/dashboard"
          className={({ isActive }) =>
            `${baseLinkClasses} ${
              isActive ? activeLinkClasses : inactiveLinkClasses
            }`
          }
          title={collapsed ? "Dashboard" : ""}
        >
          <FiHome size={20} />
          {!collapsed && <span>Dashboard</span>}
        </NavLink>

        <NavLink
          to="/products"
          className={({ isActive }) =>
            `${baseLinkClasses} ${
              isActive ? activeLinkClasses : inactiveLinkClasses
            }`
          }
          title={collapsed ? "Products" : ""}
        >
          <FiBox size={20} />
          {!collapsed && <span>Products</span>}
        </NavLink>

        <NavLink
          to="/orders-management"
          className={({ isActive }) =>
            `${baseLinkClasses} ${
              isActive ? activeLinkClasses : inactiveLinkClasses
            }`
          }
          title={collapsed ? "Orders Management" : ""}
        >
          <FiClipboard size={20} />
          {!collapsed && <span>Orders Management</span>}
        </NavLink>

        {user?.role === "admin" && (
          <NavLink
            to="/user-management"
            className={({ isActive }) =>
              `${baseLinkClasses} ${
                isActive ? activeLinkClasses : inactiveLinkClasses
              }`
            }
            title={collapsed ? "User Management" : ""}
          >
            <FiUsers size={20} />
            {!collapsed && <span>User Management</span>}
          </NavLink>
        )}
      </nav>
    </aside>
  );
};

export default Sidebar;
